import { QueryClient } from "@tanstack/react-query";
import { fetchTourMediaGallery } from "@/hooks/product-detail-page/tour-media-gallery/use-tour-media-gallery";

const prefetchTourMediaGallery = (
  queryClient: QueryClient,
  packageId: string,
  packageDateId: string,
  neoId: string
) => {
  queryClient.prefetchQuery({
    queryKey: ["PDP_TOUR_GALLERY", neoId, packageId, packageDateId],
    queryFn: fetchTourMediaGallery(packageId),
    staleTime: Infinity
  });
};

export default prefetchTourMediaGallery;